import styled from "styled-components";

export const Container = styled.div`
    padding: 20px;
    width: 100%;
    
    @media (max-width: 850px) {
        padding: 20px 0px;
    }

    h2 {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 18px;
        font-weight: 600;
        margin: 0;
    }
`;
